export default __webpack_public_path__ + "static/media/ModalImage19.e4989db7.PNG";